<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style  lang="css">
.rsu {
  font-family: "rsu", sans-serif !important;
  font-size: 1.15rem;
}

.Montserrat {
  font-family: "Montserrat", sans-serif !important;
}

.Kanit {
  font-family: "Kanit", sans-serif !important;
}

.swal2-modal {
  font-family: "Montserrat", "Kanit", sans-serif !important;
}
</style>
